import React, { useRef, useState, useEffect } from 'react';

import { Button, Select } from 'antd';

import NewForm from '../../components/Product/NewForm';
import Table from '../../components/Product/Table';
import Page from '../../layout/Page';
import api from '../../services/api';
import { ButtonContainer } from './styles';

function Product() {
  const newRef = useRef();
  const tableRef = useRef();
  const [appIntegrations, setAppIntegrations] = useState([]);
  const [selectedAppIntegration, setSelectedAppIntegration] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/appintegration');
        setAppIntegrations(data);
      } catch (err) {
        console.error('Failed to load app integrations', err);
      }
    })();
  }, []);

  return (
    <Page title="Gerenciador de Produtos" selectedKey="7">
      <ButtonContainer>
        <Select
          placeholder="Selecione um App de Integração"
          value={selectedAppIntegration}
          onChange={setSelectedAppIntegration}
          style={{ width: 300 }}
        >
          {appIntegrations.map((app) => (
            <Select.Option key={app._id} value={app._id}>
              {app.name}
            </Select.Option>
          ))}
        </Select>
        <Button
          type="primary"
          onClick={() => newRef.current.open(selectedAppIntegration)}
          disabled={!selectedAppIntegration}
        >
          Cadastrar
        </Button>
      </ButtonContainer>
      <NewForm ref={newRef} onSuccess={() => tableRef.current?.reload()} />
      <Table ref={tableRef} appIntegrationId={selectedAppIntegration} />
    </Page>
  );
}

export default Product;
